/* eslint-disable */
import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import AppContext from "../../../../context/store";
import { Grid, Column } from "../../../../theme/Grid";
import AutocompleteInput from "../../../../theme/CustomMUI/AutoComplete";
import Button from "../../../../theme/Button";
import Input from "../../../../theme/CustomMUI/Input";
import AlertDialog from "../../../../theme/CustomMUI/AlertDialog";
import DatePickerInput from "../../../../theme/CustomMUI/DatePickerInput";
import { toast } from "react-toastify";
import moment from "moment";
import {
  AddBox,
  AddOutlined,
  AddShoppingCart,
  Search
} from "@material-ui/icons";
import { AiOutlineBarcode } from "react-icons/ai";
import RemainingDebtRed from "../../../../assets/images/svg/remaining_debt_red.svg";
import StaffSelect from "../../../../theme/CustomMUI/StaffSelect";
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";
import Cash from "../../../../assets/images/svg/cash.svg";
import Credit from "../../../../assets/images/svg/credit.svg";
import Transfer from "../../../../assets/images/svg/transfer.svg";
import CustomerPoint from "../../../../assets/images/svg/customer_point.svg";
import CashWhite from "../../../../assets/images/svg/cash_white.svg";
import CreditWhite from "../../../../assets/images/svg/credit_white.svg";
import CustomerPointWhite from "../../../../assets/images/svg/customer_point_white.svg";
import TransferWhite from "../../../../assets/images/svg/transfer_white.svg";
import RemainingDebt from "../../../../assets/images/svg/remaining_debt.svg";
import MaskedInput from "../../../../theme/CustomMUI/MaskedInput";
import Select from "../../../../theme/CustomMUI/Select";

const themeForDatePicker = createTheme({
  typography: {
    fontSize: 11,
  },
});

/**
 * Ürün satışını eklemek için açılan dialog.
 */
export const _ProductSalesDialogBuilder = ({
  product_transaction,
  setProductTransaction,
  selected_stock,
  setSelectedStock,
  product_transaction_modal,
  setProductTransactionModal,
  addSingleStockSaleIntoCheckout,
  openInput,
  setOpenInput,
  barcodeValue,
  setBarcodeValue,
  setStockItemValue,
  staffs,
  stock_items,
  stock_item_value,
  searchStockByKey,
  stockItemHandler,
  checkout_data,
  getTotalAmounts,
}) => {
  const context = useContext(AppContext);

  return (
    <AlertDialog
      containerStyle={{
        overflow: "visible",
      }}
      fullWidth
      maxWidth="sm"
      title={context.t(`['receipt/detail/id'].stockSale.title`)}
      open={product_transaction_modal}
      closeHandler={() => setProductTransactionModal(false)}
      buttons={[
        {
          title: context.t(
            `['receipt/detail/id'].stockSale.addButtonTitle`
          ),
          icon: "check",
          backgroundColor: "primary-opacity",
          textColor: "primary",
          onClick: () => {
            if (selected_stock.limit !== 0) {
              addSingleStockSaleIntoCheckout();
            }
            if (selected_stock.limit === 0) {
              toast.error(context.t(`["receipt/detail/id"].stockSaleErrorToast`));
            }
            setOpenInput(false);
            setBarcodeValue("");
            setStockItemValue(null);
          },
        },

        {
          title: context.t(
            `['receipt/detail/id'].stockSale.discardButtonTitle`
          ),
          icon: "close",
          textColor: "grey",
          marginLeft: openInput ? "50px" : "0px",
          onClick: () => {
            setOpenInput(false);
            setBarcodeValue("");
            setStockItemValue(null);
          },
        },
      ]}
    >
      <StaffSelect
        disabled={context.state.user.permission === 0}
        label={context.t(
          `['receipt/detail/id'].stockSale.staffInputLabel`
        )}
        items={staffs}
        selected={
          product_transaction.staff_id !== null
            ? product_transaction.staff_id
            : null
        }
        labelKey="full_name"
        valueKey="id"
        returnFullObject
        handler={(staff) =>
          setProductTransaction({
            ...product_transaction,
            staff_id: parseInt(staff.id),
          })}
      />

      <AutocompleteInput
        label={context.t(
          `['receipt/detail/id'].stockSale.stockInputLabel`
        )}
        showField="amount"
        extraLimit="limit"
        labelKey="name"
        opcStyle={{ maxHeight: "30vh" }}
        valueKey="id"
        selected={
          stock_items !== null ? stock_items : ""
        }
        value={
          stock_item_value !== null
            ? stock_item_value
            : null
        }
        onRemove={() => {
          searchStockByKey("");
        }}
        returnFullObject
        selectedHandler={(stock_item) => {
          setProductTransaction({
            ...product_transaction,
            stock_item_id: parseInt(stock_item.id),
            amount: stock_item.amount,
          });
          setSelectedStock(stock_item);
        }}
        asyncDataService={(keyword) =>
          keyword.length > 0 ? searchStockByKey(keyword) : []
        }
      />
      <div
        style={{ width: "100%", display: "flex", justifyContent: "center" }}
      >
        {!openInput ? (
          <button
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              border: "none",
              background: "rgb(49, 137, 236)",
              color: "white",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "background 0.3s, color 0.3s",
              disabled: true,
            }}
            onClick={() => {
              if (context.state?.balance?.data?.license?.barcode) {
                setOpenInput(true);
              } else {
                toast.warn(
                  context.t(
                    `['receipt/detail/id'].stockSales.barcodeCheckAlert`
                  )
                );
              }
            }}
            onMouseEnter={(e) => {
              e.target.style.opacity = "0.7";
            }}
            onMouseLeave={(e) => {
              e.target.style.opacity = "1";
            }}
          >
            {context.t(
              `['receipt/detail/id'].stockSales.selectWithBarcode`
            )}
            <AiOutlineBarcode
              color="black"
              size={"30px"}
              style={{ marginLeft: "15px" }}
            />
          </button>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <input
                style={{
                  width: "300px",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  outline: "none",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "border-color 0.3s",
                  flex: 1,
                }}
                placeholder={context.t(`["receipt/detail/id"].barcodeInputPlaceholder`)}
                type="text"
                value={barcodeValue ? barcodeValue : ""}
                onChange={(event) => {
                  setBarcodeValue(event.target.value);
                }}
              />
              <button
                style={{
                  padding: "10px 20px",
                  borderRadius: "5px",

                  background: [
                    barcodeValue === "" ? "#8db7e7 " : "#3189ec ",
                  ],
                  border: "none",
                  color: "#fff",
                  cursor: "pointer",
                }}
                onClick={() => {
                  barcodeValue
                    ? stockItemHandler()
                    : toast.warn(
                      context.t(
                        `['receipt/detail/id'].barcodeAlert.pleaseEnterACode`
                      )
                    );
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = barcodeValue !== "" ? "0.8" : null;
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = barcodeValue !== "" ? "1" : null;
                }}
              >
                {context.t(
                  `['receipt/detail/id'].stockSales.selectStock`
                )}
              </button>
            </div>
            <span
              style={{ cursor: "pointer", marginLeft: "5px" }}
              onClick={() => setOpenInput(false)}
            >
              &#10006;
            </span>
          </div>
        )}
      </div>

      {/* <Select
        label={context.t(
          `['receipt/detail/id'].stockSale.stockInputLabel`
        )}
        items={state.stock_items}
        selected={product_transaction.stock_item_id}
        labelKey="name"
        valueKey="id"
        returnFullObject
        handler={(stock_item) =>
          setState({
            product_transaction: {
              ...product_transaction,
              stock_item_id: parseInt(stock_item.id),
              amount: stock_item.amount,
            },
          })
        }
      /> */}
    </AlertDialog>
  );
};

//** */ Ürün satışının yapıldığı, verilerin düzenlendiği alan.

export const _ProductSalesBuilder = ({
  setProductDetailDialogModal,
  setProductTransaction,
  _product_transaction,
  setProductTransactionModal,
  checkout_data,
  setCheckoutData,
  stock_items,
  staffs,
  getTotalAmounts,
  setDiscountTarget,
  setDiscountType,
  setDiscountValue,
  setDiscountModal,
  advanced_date,
  advanced_type,
  setAdvancedDate,
  setAdvancedType,
  setAdvancedStaff,
  setPaymentSelectStaff,
  payment_select_staff,
  advanced_amount,
  setAdvancedAmount,
  singlePaymentAndInstallmentPayment,
}) => {
  const context = useContext(AppContext);
  let total_mount = 0;
  const rounded_amount = Math.round(getTotalAmounts().services);
  const [installment_dialog, setInstallmentDialog] = useState(false);
  const [installment_date, setInstallmentDate] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [selected_installment, setSelectedInstallment] = useState(null);
  const [selected, setSelected] = useState(null);
  const [addPayment_dialog, setAddPaymentDialog] = useState(false);

  const getInstallmentDiffTotal = (count) => {
    console.log(selected)
    const total = selected?.amount;
    return count > 0
      ? total / count
      : 0
  };


  let amountData = Object.keys(checkout_data.services).map((key) =>
    checkout_data.services[key] !== undefined
      ? checkout_data.services[key].amount !== NaN
        ? checkout_data.services[key].amount
        : 0
      : 0
  );

  for (let i = 0; i < amountData.length - 1; i++) {
    total_mount += Math.round(amountData[i]);
  }

  for (let j = 0; j < amountData.length; j++) {
    amountData[j] = Math.round(amountData[j]);
    if (amountData[amountData.length - 1]) {
      amountData[amountData.length - 1] = rounded_amount - total_mount;
    }
  }

  useEffect(() => {
    Object.keys(checkout_data.services).map((key) => {
      checkout_data.services[key] !== undefined
        ? checkout_data.services[key].amount !== NaN
          ? (checkout_data.services[key].amount = Math.round(amountData[key]))
          : 0
        : 0;
    });
  }, [checkout_data]);

  return (
    <SectionBox style={{ overflowX: "hidden" }}>
      <SectionHeading
        style={{
          backgroundColor: "rgba(49, 169, 243, 0.24)",
          color: "#3189ec",
          border: "1px solid #3189ec",
          padding: "10px",
          borderRadius: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div
          className="detail-search"
          style={{
            backgroundColor: "#3189ec",
          }}
          onClick={() => {
            setProductDetailDialogModal(true);
          }}
        >
          <Search style={{ color: "white", fontSize: "20px" }} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <AddShoppingCart />
          <h3 style={{ marginLeft: "15px" }}>
            {context.t(`['receipt/detail/id'].stockSales.title`)}
          </h3>
        </div>
        <div>
          <AddBox
            style={{ cursor: "pointer", fontSize: "36px" }}
            onClick={() => {
              setProductTransaction({ ..._product_transaction })
              setProductTransactionModal(true);
            }}
          />
        </div>
      </SectionHeading>

      <ListSection className="no-scroll-bar">
        {Object.keys(checkout_data.sales).filter(
          (key) => checkout_data.sales[key] !== undefined
        ).length ? (
          Object.keys(checkout_data.sales).map(
            (key) =>
              checkout_data.sales[key] !== undefined && (
                <Grid className="no-gutters-row">
                  <Column className="xs-12 sm-12 md-12 mt-1 lg-2">
                    <MuiThemeProvider theme={themeForDatePicker}>
                      <DatePickerInput
                        className="mb-1"
                        label={context.t(
                          `['receipt/detail/id'].serviceTransactions.dateInputLabel`
                        )}
                        error={false}
                        value={
                          moment(checkout_data.sales[key].sold_date).format(
                            "YYYY-MM-DD"
                          ) === "0001-01-01"
                            ? null
                            : moment(checkout_data.sales[key].sold_date)
                        }
                        //  disabled={true}
                        onChange={(process_date) => {
                          setCheckoutData({
                            ...checkout_data,
                            sales: {
                              ...checkout_data.sales,
                              [key]: {
                                ...checkout_data.sales[key],
                                sold_date:
                                  moment(process_date).toISOString(),
                              },
                            }
                          });
                        }}
                      />
                    </MuiThemeProvider>
                  </Column>

                  <Column className="xs-12 sm-12 md-12 lg-3">
                    <Input
                      className="mb-1"
                      readOnly
                      label={context.t(
                        `['receipt/detail/id'].stockSales.nameInputLabel`
                      )}
                      inputProps={{
                        style: {
                          color: `${checkout_data.sales[key].stock_item?.is_passive
                            ? "red"
                            : "black"
                            }`,
                        },
                      }}
                      value={
                        checkout_data.sales[key].stock_item_id
                          ? stock_items.filter(
                            (item) =>
                              item.id ===
                              checkout_data.sales[key].stock_item_id
                          ).length
                            ? stock_items.filter(
                              (item) =>
                                item.id ===
                                checkout_data.sales[key].stock_item_id
                            )[0].name
                            : context.t(
                              `['receipt/detail/id'].stockSales.deletedName`
                            )
                          : context.t(
                            `['receipt/detail/id'].stockSales.deletedName`
                          )
                      }
                    />
                  </Column>

                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <StaffSelect
                      className="mb-2"
                      disabled={context.state.user.permission === 0}
                      label={context.t(
                        `['receipt/detail/id'].stockSales.staffInputLabel`
                      )}
                      items={staffs}
                      selected={
                        checkout_data.sales[key].staff_id
                          ? checkout_data.sales[key].staff_id
                          : null
                      }
                      labelKey="full_name"
                      valueKey="id"
                      handler={(staff_id) => {
                        setCheckoutData({
                          ...checkout_data,
                          sales: {
                            ...checkout_data.sales,
                            [key]: {
                              ...checkout_data.sales[key],
                              staff_id: parseInt(staff_id),
                            },
                          }
                        });
                      }}
                    />
                  </Column>

                  {/* INPUTCHECK */}
                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Input
                      className="mb-2"
                      label={context.t(
                        `['receipt/detail/id'].stockSales.countInputLabel`
                      )}
                      value={checkout_data.sales[key].quantity}
                      onChange={(e) => {
                        setCheckoutData({
                          ...checkout_data,
                          sales: {
                            ...checkout_data.sales,
                            [key]: {
                              ...checkout_data.sales[key],
                              quantity:
                                e.target.value &&
                                  /[0-9]+/.test(e.target.value)
                                  ? parseInt(e.target.value)
                                  : 0,
                            },
                          }
                        });
                      }}
                    />
                  </Column>

                  <Column className="xs-12 sm-12 md-12 lg-2">
                    <Input
                      readOnly
                      className="mb-2"
                      type="number"
                      label={
                        context.t(
                          `['receipt/detail/id'].stockSales.amountInputLabel`
                        ) +
                        (context.state.currency
                          ? " (" + context.state.currency + ")"
                          : "(₺)")
                      }
                      value={checkout_data.sales[key].amount}
                      onChange={(e) => {
                        setCheckoutData({
                          ...checkout_data,
                          sales: {
                            ...checkout_data.sales,
                            [key]: {
                              ...checkout_data.sales[key],
                              amount:
                                e.target.value &&
                                  /[0-9,.]+/.test(e.target.value)
                                  ? parseFloat(e.target.value)
                                  : 0,
                            },
                          }
                        });
                      }}
                    />
                  </Column>
                  <Column className="xs-12 sm-12 md-12 lg-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row' }}>
                    {(!checkout_data.sales[key].button_passive && checkout_data.sales[key].id) && (
                      <Column className="xs-6">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: '100%', gap: '5px', marginTop: '-5px' }}>
                          <img src={Credit} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                            setInstallmentDialog(true);
                            // Find the package that matches the current data
                            const packageData = { ...checkout_data?.sales[key] }
                            setSelected(packageData ? packageData : {});
                          }} />
                          <img src={Cash} title="Ödeme Ekle" style={{ cursor: "pointer" }} alt="credit" width="25px" height="25px" onClick={() => {
                            setAddPaymentDialog(true);
                            // Find the package that matches the current data
                            const packageData = checkout_data?.sales[key]
                            setSelected(packageData ? packageData : {});
                          }} />
                        </div>
                        <AlertDialog
                          title={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "5px",
                              }}
                            >
                              <AddOutlined
                                style={{
                                  color: "#6097D2",
                                }}
                              />
                              <span
                                style={{
                                  color: "#6097D2",
                                }}
                              >
                                {context.t(`['receipt/detail/id'].addPaymentTitle`)}
                              </span>
                            </div>
                          }
                          open={addPayment_dialog}
                          fullWidth
                          maxWidth="xs"
                          closeHandler={() => setAddPaymentDialog(false)}
                          buttons={[
                            {
                              title: context.t(
                                `appointments.create.completePaymentButtonTitle`
                              ),
                              validationButton: true,
                              icon: "check",
                              backgroundColor: "green",
                              style: {
                                height: "56px",
                              },
                              textColor: "white",
                              onClick: () => {
                                if (!advanced_date || !advanced_amount || advanced_amount <= 0) {
                                  toast.error('Lütfen tüm alanları doldurunuz!');
                                  return;
                                }
                                singlePaymentAndInstallmentPayment({
                                  receipt_id: parseInt(checkout_data.receipt_id),
                                  id: parseInt(checkout_data.sales[key].id),
                                  receipt_type: 3,
                                  is_installment: false,
                                  payments: [{
                                    payment_date: moment(advanced_date).toISOString(),
                                    payment_type: advanced_type,
                                    staff_id: parseInt(payment_select_staff?.staff_id),
                                    amount: parseFloat(advanced_amount),
                                    payment_status: 1,
                                  }]
                                })
                                setSelected(null)
                                setSelectedInstallment(null)
                                setInstallmentDate(null)
                                setSelectedStaff(null)
                                setAdvancedDate(new Date())
                                setAdvancedType(0)
                                setAdvancedStaff(null)
                                setAdvancedAmount(null)
                                setPaymentSelectStaff({})
                                setAddPaymentDialog(false)
                              },
                            },
                            {
                              title: context.t(`appointments.create.discardButtonTitle`),
                              icon: "close",
                              backgroundColor: "white",
                              style: {
                                border: "1px solid #666666",
                                height: "56px",
                              },
                              textColor: "black",
                              onClick: () => {
                                setAddPaymentDialog(false);
                                setPaymentSelectStaff({});
                                setAdvancedStaff(null);
                              },
                            },
                          ]}
                        >
                          <>
                            <Column>
                              <span
                                style={{
                                  marginBottom: "10px",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
                              </span>
                              <DatePickerInput
                                // label={context.t(
                                //   `['receipt/detail/id'].payments.dateInputLabel`
                                // )}
                                value={moment(advanced_date).local().toISOString() || new Date()}
                                onChange={(payment_date) => {
                                  setAdvancedDate(payment_date);
                                }}
                              />
                            </Column>
                            <Column>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <AdvancedType
                                  style={{
                                    backgroundColor: advanced_type == 0 ? "#78B8FF" : "#FFFFFF",
                                    filter:
                                      advanced_type == 0
                                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                    border:
                                      advanced_type == 0
                                        ? "1px solid #6BB0FE"
                                        : "1px solid #b8b8b8",
                                  }}
                                  onClick={() => setAdvancedType(0)}
                                >
                                  {advanced_type == 0 ? (
                                    <img src={CashWhite} alt="cash_white" />
                                  ) : (
                                    <img src={Cash} alt="cash" />
                                  )}
                                  <span
                                    style={{
                                      color: advanced_type == 0 ? "#FFFFFF" : "#000000",
                                    }}
                                  >
                                    {context.t(`accounting.typeCASH`)}
                                  </span>
                                </AdvancedType>
                                <AdvancedType
                                  style={{
                                    marginLeft: "10px",
                                    backgroundColor: advanced_type == 2 ? "#78B8FF" : "#FFFFFF",
                                    filter:
                                      advanced_type == 2
                                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                    border:
                                      advanced_type == 2
                                        ? "1px solid #6BB0FE"
                                        : "1px solid #b8b8b8",
                                  }}
                                  onClick={() => {
                                    setAdvancedType(2);
                                  }}
                                >
                                  {advanced_type == 2 ? (
                                    <img src={TransferWhite} alt="transfer_white" />
                                  ) : (
                                    <img src={Transfer} alt="transfer" />
                                  )}
                                  <span
                                    style={{
                                      color: advanced_type == 2 ? "#FFFFFF" : "#000000",
                                    }}
                                  >
                                    {context.t(`accounting.typeEFT`)}
                                  </span>
                                </AdvancedType>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <AdvancedType
                                  style={{
                                    backgroundColor: advanced_type == 1 ? "#78B8FF" : "#FFFFFF",
                                    filter:
                                      advanced_type == 1
                                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                    border:
                                      advanced_type == 1
                                        ? "1px solid #6BB0FE"
                                        : "1px solid #b8b8b8",
                                  }}
                                  onClick={() => {
                                    setAdvancedType(1);
                                  }}
                                >
                                  {advanced_type == 1 ? (
                                    <img src={CreditWhite} alt="credit_white" />
                                  ) : (
                                    <img src={Credit} alt="credit" />
                                  )}
                                  <span
                                    style={{
                                      color: advanced_type == 1 ? "#FFFFFF" : "#000000",
                                    }}
                                  >
                                    {context.t(`accounting.typeCARD`)}
                                  </span>
                                </AdvancedType>
                                <AdvancedType
                                  style={{
                                    marginLeft: "10px",
                                    backgroundColor: advanced_type == 3 ? "#78B8FF" : "#FFFFFF",
                                    filter:
                                      advanced_type == 3
                                        ? "drop-shadow(0px 3px 6px #78B8FF)"
                                        : "drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.149))",
                                    border:
                                      advanced_type == 3
                                        ? "1px solid #6BB0FE"
                                        : "1px solid #b8b8b8",
                                  }}
                                  onClick={() => {
                                    setAdvancedType(3);
                                  }}
                                >
                                  {advanced_type == 3 ? (
                                    <img src={CustomerPointWhite} alt="customer_point_white" />
                                  ) : (
                                    <img src={CustomerPoint} alt="customer_point" />
                                  )}
                                  <span
                                    style={{
                                      color: advanced_type == 3 ? "#FFFFFF" : "#000000",
                                    }}
                                  >
                                    {context.t(`["accounting/expense"].payments.cusPoint`)}
                                  </span>
                                </AdvancedType>
                              </div>
                            </Column>
                            <Column>
                              <StaffSelect
                                disabled={context.state.user.permission === 0}
                                label={context.t(`["receipt/detail/id"].selectStaff`)}
                                items={staffs}
                                selected={payment_select_staff?.staff_id}
                                labelKey="full_name"
                                valueKey="id"
                                returnFullObject
                                handler={(staff) => {
                                  setAdvancedStaff(staff);
                                  setPaymentSelectStaff({
                                    ...payment_select_staff,
                                    staff_id: parseInt(staff.id),
                                  });
                                }}
                              />
                            </Column>
                            <Column>
                              <span
                                style={{
                                  marginBottom: "10px",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                {context.t(`["receipt/detail/id"].paymentAmount`)} *
                              </span>
                              <MaskedInput
                                // label={"Ödeme Tutarı"}
                                mask="9999999999999"
                                maskChar=""
                                value={advanced_amount ? advanced_amount : ""}
                                onChange={(e) => {
                                  setAdvancedAmount(e.target.value);
                                }}
                              />
                            </Column>
                          </>
                        </AlertDialog>
                        <AlertDialog
                          title={
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <span
                                style={{
                                  width: "120%",
                                  marginTop: "15px",
                                }}
                              >
                                {context.t(`['receipt/detail/id'].installmentProcess`)}
                              </span>
                              <CustomerBoxDiv>
                                {selected?.amount === 0 ? (
                                  <img src={RemainingDebt} alt="remaining_debt" />
                                ) : (
                                  <img src={RemainingDebtRed} alt="remaining_debt_red" />
                                )}
                                <CustomerPointBox>
                                  <span>
                                    {getInstallmentDiffTotal(1)}{" "}
                                    {context.state.currency ? context.state.currency : "₺"}
                                  </span>
                                  <h3>{context.t(`['receipt/detail/id'].remainingDebt`)}</h3>
                                </CustomerPointBox>
                              </CustomerBoxDiv>
                            </div>
                          }
                          open={installment_dialog}
                          closeHandler={() => setInstallmentDialog(false)}
                          fullWidth
                          maxWidth="sm"
                          buttons={[
                            {
                              title: context.t(`appointments.create.completeButtonTitle`),
                              icon: "check",
                              validationButton: true,
                              backgroundColor: "green",
                              style: {
                                height: "56px",
                              },
                              textColor: "white",
                              onClick: () => {
                                if (!installment_date || !selected_installment) {
                                  toast.error('Lütfen tüm alanları doldurunuz!');
                                  return;
                                }
                                singlePaymentAndInstallmentPayment({
                                  receipt_id: parseInt(checkout_data.receipt_id),
                                  id: parseInt(checkout_data.sales[key].id),
                                  receipt_type: 3,
                                  is_installment: true,
                                  payments: Array.from({ length: selected_installment }, (_, i) => ({
                                    payment_date:
                                      i === 0
                                        ? moment(installment_date).toISOString()
                                        : moment(installment_date)
                                          .add(i, "months")
                                          .toISOString(),
                                    payment_type: 0,
                                    staff_id: parseInt(selectedStaff),
                                    amount:
                                      getInstallmentDiffTotal(selected_installment),
                                    payment_status: 0,
                                  }))
                                })
                                setSelected(null)
                                setSelectedInstallment(null)
                                setInstallmentDate(null)
                                setSelectedStaff(null)
                                setAdvancedDate(new Date())
                                setAdvancedType(0)
                                setAdvancedStaff(null)
                                setInstallmentDialog(false)
                              },
                            },
                            {
                              title: context.t(`appointments.create.discardButtonTitle`),
                              icon: "close",
                              backgroundColor: "white",
                              style: {
                                border: "1px solid #666666",
                                height: "56px",
                              },
                              textColor: "black",
                              onClick: () => setInstallmentDialog(false),
                            },
                          ]}
                        >
                          <>
                            <Column>
                              <span
                                style={{
                                  marginBottom: "10px",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                {context.t(`["receipt/detail/id"].payments.dateInputLabel`)} *
                              </span>
                              <DatePickerInput
                                // label={context.t(
                                //   `['receipt/detail/id'].payments.dateInputLabel`
                                // )}
                                value={moment(installment_date).local().toISOString() || new Date()}
                                onChange={(payment_date) => {
                                  setInstallmentDate(payment_date);
                                }}
                              />
                            </Column>
                            <Column>
                              <span
                                style={{
                                  marginBottom: "10px",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                {context.t(`["receipt/detail/id"].installmentStaffInputLabel`)} *
                              </span>
                              <StaffSelect
                                className="mb-1"
                                disabled={context.state.user.permission === 0}
                                label={context.t(
                                  `['receipt/detail/id'].serviceTransactions.staffInputLabel`
                                )}
                                items={staffs}
                                selected={selectedStaff ? selectedStaff : ""}
                                labelKey="full_name"
                                valueKey="id"
                                handler={(staff_id) => {
                                  setSelectedStaff(staff_id)
                                }}
                              />
                            </Column>
                            <Column>
                              <span
                                style={{
                                  marginTop: '20px !important',
                                  marginBottom: "10px",
                                  marginLeft: "5px",
                                  fontSize: "18px",
                                }}
                              >
                                {context.t(`["receipt/detail/id"].installmentCountInputLabel`)} *
                              </span>
                              <Select
                                // label={context.t(
                                //   `['receipt/detail/id'].installmentCountInputLabel`
                                // )}
                                labelKey="label"
                                valueKey="value"
                                items={[
                                  { value: 2, label: context.t(`["receipt/detail/id"].installments.two`) },
                                  { value: 3, label: context.t(`["receipt/detail/id"].installments.three`) },
                                  { value: 4, label: context.t(`["receipt/detail/id"].installments.four`) },
                                  { value: 5, label: context.t(`["receipt/detail/id"].installments.five`) },
                                  { value: 6, label: context.t(`["receipt/detail/id"].installments.six`) },
                                  { value: 7, label: context.t(`["receipt/detail/id"].installments.seven`) },
                                  { value: 8, label: context.t(`["receipt/detail/id"].installments.eight`) },
                                  { value: 9, label: context.t(`["receipt/detail/id"].installments.nine`) },
                                  { value: 10, label: context.t(`["receipt/detail/id"].installments.ten`) },
                                  { value: 11, label: context.t(`["receipt/detail/id"].installments.eleven`) },
                                  { value: 12, label: context.t(`["receipt/detail/id"].installments.twelve`) },
                                ]}
                                selected={selected_installment ? selected_installment : null}
                                handler={(installment) => {
                                  setSelectedInstallment(installment);
                                }}
                              />
                            </Column>
                            {selected_installment && (
                              <Column>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <p style={{ marginRight: "5px" }}>{context.t(`["receipt/detail/id"].payments.title`)}:</p>
                                  <p>
                                    {Math.round(getInstallmentDiffTotal(selected_installment))}
                                    {context.state.currency
                                      ? context.state.currency
                                      : "₺"} x {selected_installment}
                                  </p>
                                </div>
                              </Column>
                            )}
                          </>
                        </AlertDialog>
                      </Column>
                    )}
                    {!checkout_data.sales[key].button_passive && (
                      <Column className="xs-6">
                        <Button
                          style={{
                            marginLeft: '-10px',
                          }}
                          icon="delete_forever"
                          iconSize={21}
                          textColor="red"
                          size="lg"
                          fullWidth
                          onClick={() => {
                            setCheckoutData({
                              ...checkout_data,
                              sales: {
                                ...checkout_data.sales,
                                [key]: undefined,
                              },
                            });
                          }}
                        />
                      </Column>
                    )}
                  </Column>
                </Grid>
              )
          )
        ) : (
          <NoDataContainer style={{ height: "80%" }}>
            <img
              src={require("../../../../assets/images/no-data-img.png")}
              alt="Malesef bulunamadı!"
            />
            <p>
              {context.t(`['receipt/detail/id'].stockSales.noDataText`)}
            </p>
          </NoDataContainer>
        )}
      </ListSection>

      {Object.keys(checkout_data.sales).filter(
        (key) => checkout_data.sales[key] !== undefined
      ).length > 0 && (
          <SubTotalText className="mt-2">
            <CustomerBoxDiv>
              <Button
                style={{
                  border: "1px solid rgba(255, 127, 80, 0.53)",
                }}
                disabled={
                  Object.keys(checkout_data.sales).filter(
                    (key) => checkout_data.sales[key] !== undefined
                  ).length === 0
                }
                className="mr-2"
                icon="emoji_symbols"
                title={context.t(
                  `['receipt/detail/id'].applyDiscountButtonTitle`
                )}
                backgroundColor="orange-opacity"
                textColor="orange"
                onClick={() => {
                  if (
                    Object.keys(checkout_data.paids).filter(
                      (key) => checkout_data.paids[key] !== undefined
                    ).length === 0 &&
                    Object.keys(checkout_data.installment).filter(
                      (key) => checkout_data.installment[key] !== undefined
                    ).length === 0
                  ) {
                    setDiscountTarget("sales");
                    setDiscountValue(null);
                    setDiscountType("TL");
                    setDiscountModal(true);
                  } else {
                    toast.warning(
                      context.t(
                        `['receipt/detail/id'].discountBeforePaymentToast`
                      )
                    );
                  }
                }}
              />

              <div
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={RemainingDebtRed} alt="remaining_debt_red" />
                <CustomerPointBox>
                  {getTotalAmounts().sales !=
                    getTotalAmounts()._fsales ? (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <p
                        style={{ textDecoration: "line-through" }}
                        className="fc-grey mr-1"
                      >
                        {getTotalAmounts()._fsales.toFixed(0)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                      <p>
                        {getTotalAmounts().sales.toFixed(0)}
                        {context.state.currency
                          ? context.state.currency
                          : "₺"}
                      </p>
                    </span>
                  ) : (
                    <p>
                      {getTotalAmounts().sales.toFixed(0)}
                      {context.state.currency
                        ? context.state.currency
                        : "₺"}
                    </p>
                  )}
                  <h3>
                    {context.t(
                      `['receipt/detail/id'].stockSales.totalAmount`
                    )}
                  </h3>
                </CustomerPointBox>
              </div>
            </CustomerBoxDiv>
          </SubTotalText>
        )}
    </SectionBox>
  );
};

const InfoCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 5px;
  padding: 2px 5px;
  height: 40px;
  width: 40px;
  cursor: pointer;
`;

const InfoCardText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 5px;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const ReportsHeader = styled.div`
  width: 100%;
  cursor: pointer;
  font-size: 1.2em;
  font-weight: 500;
  display: flex;
  color: #4d4d4d;
  display: flex;
  align-items: center;
  justify-content: start;
`;

const ReportsHeaderIcon = styled.span`
  padding-right: 10px;
`;
const ReportsContainer = styled.div`
  border-bottom: 1px solid #b2b2b2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5em;
  flex-direction: column;
  overflow: hidden;
`;
const SectionBox = styled.div`
  width: 100%;
  overflow-x: scroll;
  box-sizing: border-box;
  padding-top: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  color: var(--dark-primary);

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const ListSection = styled.div`
  overflow-x: scroll;
  margin-bottom: auto;
  padding-left: 5px;
  padding-right: 5px;
`;

const PaymentSection = styled.div`
  width: 95%;
  height: 57px;
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  border-radius: 5px;
`;

const SubTotalText = styled.div`
  span {
    font-size: 13px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }

  p {
    font-size: 17px;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
`;

const CustomerBox = styled.div``;

const CustomerBoxDiv = styled.div`
  width: 100%;
  height: 57px;
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 5px;

  img {
    width: 30px;
    height: 30px;
    margin-right: 8px;
    margin-top: 7px;
    margin-left: 10px;
  }
`;

const CustomerPointBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  margin-top: 5px;

  h3 {
    font-size: 13px;
    font-weight: 500;
    margin: 0;
    color: #3c3c3c;
  }

  span {
    font-size: 15px;
    font-weight: 500;
    line-height: 15px;

    b {
      font-size: 13px;
      font-weight: 400;
      color: #aaa;
    }
  }
`;

const SelectedBoxPhoto = styled.img`
  width: 52px;
  height: 52px;
  object-fit: cover;
  border-radius: 5px;
  background-color: #fafafa;
  margin-right: 16px;
`;

const CustomerBoxInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media only screen and (max-width: 576px) {
    flex - direction: column;
    div, img {margin: 0 !important}
  }

  div{
    b, span {margin: 0; padding: 0; display: block;}
    b{
      font - size: 15px; font-weight: 500
    }

    &.call_button{
      margin - left: 24px;
      flex: 1
      display:flex;
      justify-content: flex-end;
    }
  }
`;

const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 16px;

  img {
    width: 100%;
    max-height: 32vh;
    object-fit: contain;
  }
  p {
    color: #407bff;
    font-size: 18px;
    font-weight: 500;
    padding-top: 16px;
    text-align: center;
  }
`;

const AdvancedType = styled.div`
  display: flex;
  width: 190px;
  height: 88px;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
`;

const ColorMean = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
  justify-content: center;

  &:nth-last-child(1) {
    margin: 0;
  }

  div.color {
    width: 20px;
    height: 20px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    margin-right: 8px;

    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        -180deg,
        rgba(255, 255, 255, 0.25) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  span {
    flex: 1;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500;
    color: #000000;
  }
`;

const ImageUploadBox = styled.label`
  display: flex;
  width: -webkit-fill-available;
  padding: 32px;
  text-align: center;
  align-items: center;
  justify-content: center;
  background: #fefefe;
  border: 2px dotted #eaeaea;
  border-radius: 5px;
  cursor: pointer;
  color: #808080;
  font-size: 15px;
  font-weight: 500;
  transition: all ease 0.35s;

  &:hover {
    border: 2px dotted #dadada;
    color: #000;
  }

  i.material-icons {
    font-size: 21px;
    margin-right: 8px;
  }
`;

const ReceiptProfile = styled.div`
  display: flex;
  flex-direction: column;
  height: 57px;
  width: 100%;
  border-radius: 5px;

  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 100%;
    padding: 2px;
  }
`;

const SaveChangesButton = styled.div`
  position: fixed;
  top: 75px;
  right: 4vw;
  z-index: 999;
  width: 20vw;
`;

const ServicesSectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  color: var(--dark-primary);
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  margin-bottom:16px;

  h3{font - size: 18px; font-weight: 600; flex: 1; margin: 0; padding: 0}
`;

const StaffList = styled.div`
  height: 26vh;
  box-shadow: inset 0 0 5px #3189ec;
  border-radius: 10px;
  -webkit-overflow-scrolling: touch;
  overflow: scroll;
  margin: 0;
`;

const ServicesList = styled.div`
  height: 22.5vh;
  box-shadow: inset 0 0 5px #3189ec;
  border-radius: 10px;
  overflow: scroll;
`;

const Services = styled.div`
  height: 63vh;
  border-radius: 10px;
  overflow: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PackageDetailContainer = styled.div`
  flex-direction: column;
  overflow: hidden;
`;
